<template>
  <div>
    <div v-if="isCondensed" class="condensed" :style="props.condensedStyle">
      <div v-if="btnLabel" class="btn-wrapper">
        <button class="btn btn-light" @click="handleBtnClick">
          {{ $t(props.btnLabel) }}
        </button>
      </div>
      <VDropdown class="info-popover" placement="left">
        <a href="#" class="link-main icon-link" @click.prevent>
          <Icon icon="info-circle" /> {{ $t('GENERAL.GET_HELP') }}
        </a>
        <template #popper>
          {{ $t(props.text) }}
        </template>
      </VDropdown>
    </div>
    <div v-else class="inline-onboarding">
      <Icon icon="graduation" />
      <div class="onboarding-content">
        <p v-if="heading" class="heading">{{ $t(heading) }}</p>
        <p>{{ $t(props.text) }}</p>
      </div>
      <div v-if="btnLabel" class="btn-wrapper">
        <button class="btn btn-ghost" @click="handleBtnClick">
          {{ $t(props.btnLabel) }}
        </button>
      </div>

      <button class="link link-underlined condense" @click="condense">
        {{ $t('GENERAL.DISMISS') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

interface Props {
  text?: string;
  heading?: string;
  condensed?: boolean;
  condensedStyle?: Record<string, string | number>;
  btnLabel?: string;
}

const emit = defineEmits<{
  btnClick: [];
}>();

const forceCondensed = ref<boolean>(false);

const props = withDefaults(defineProps<Props>(), {
  text: '',
  heading: '',
  condensed: false,
  condensedStyle: () => ({}),
  btnLabel: '',
});

const isCondensed = computed(() => props.condensed || forceCondensed.value);

const handleBtnClick = (): void => {
  emit('btnClick');
};

const condense = (): void => {
  forceCondensed.value = true;
};
</script>

<style scoped lang="scss">
@import 'src/scss/constants';
@import 'src/scss/styleguide/colors';

.condense {
  font-weight: normal;
}

.inline-onboarding {
  display: flex;
  padding: 12px;
  background-color: #b0cfeb;
  border-radius: $border-radius-medium;

  .icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .onboarding-content {
    flex-grow: 1;
  }

  p {
    margin: 0;
  }

  .heading {
    font-weight: bold;
    margin-bottom: 4px;
  }

  button {
    margin-left: 16px;
  }

  .btn-wrapper {
    display: flex;
    align-items: center;
  }
}

.condensed {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
